import { LOGIN } from '../routes';
import { parseJwt } from './helpers';

const SESSION_KEY = '_recharge_session';

export const setSession = (data, isWhitelisted) => {
  const { session, hasNotActivatedSub } = data;
  if (!session) {
    return null;
  }
  const parsedJwt = parseJwt(session.apiToken);

  const item = {
    value: session,
    hasNotActivatedSub,
    expiry: parsedJwt.exp,
    customerId: session.customerId,
    isWhitelisted: isWhitelisted || false,
  };

  localStorage.setItem(SESSION_KEY, JSON.stringify(item));
};

export const getSession = () => {
  const itemStr = localStorage.getItem(SESSION_KEY);
  if (!itemStr) {
    return null;
  }

  let item;
  try {
    item = JSON.parse(itemStr);
  } catch {
    return null;
  }

  if (Date.now() / 1000 > item.expiry) {
    removeSession();
    window.location = LOGIN;
    return null;
  }

  return item.value;
};

export const getFullSession = () => {
  const itemStr = localStorage.getItem(SESSION_KEY);
  if (!itemStr) {
    return null;
  }

  let item;
  try {
    item = JSON.parse(itemStr);
  } catch {
    return null;
  }

  return item;
};

export const getCustomerId = () => {
  const itemStr = localStorage.getItem(SESSION_KEY);
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);

  return item.customerId;
};

export const getHasNotActivatedSub = () => {
  const itemStr = localStorage.getItem(SESSION_KEY);
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);

  return item.hasNotActivatedSub;
};

export const removeSession = () => {
  localStorage.removeItem(SESSION_KEY);
};

export const resetHasNotActivatedSub = () => {
  const itemStr = localStorage.getItem(SESSION_KEY);
  if (!itemStr) {
    return;
  }

  const item = JSON.parse(itemStr);
  localStorage.setItem(
    SESSION_KEY,
    JSON.stringify({ ...item, hasNotActivatedSub: false }),
  );
};

export const getIsWhitelisted = () => {
  const itemStr = localStorage.getItem(SESSION_KEY);
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);

  return item.isWhitelisted;
};
